import React, { useState } from 'react';
import { Truck, Building2, Image as ImageIcon, Upload, FileCheck2, PencilLine, Ban, History } from 'lucide-react';
import { BadgeCopia } from './Badge';
import { dataIt, urlDocumento } from './api';

const Storico = ({ prelievo }) => (
  <div className="mt-3 border-t border-gray-100 pt-2 space-y-2" data-testid={`oli-storico-${prelievo.id}`}>
    {(prelievo.storico_correzioni || []).map((c, i) => (
      <div key={i} className="text-xs text-gray-600">
        <p className="font-medium text-gray-800">{dataIt(c.data_ora)} · {c.nome}: {c.motivo}</p>
        {Object.entries(c.modifiche || {}).map(([k, v]) => (
          <p key={k} className="pl-2">{k.replace(/_/g, ' ')}: <s>{String(v.prima ?? '-')}</s> → {String(v.dopo ?? '-')}</p>
        ))}
      </div>
    ))}
  </div>
);

const Azione = ({ onClick, testid, title, children, colore = 'text-gray-500' }) => (
  <button onClick={onClick} data-testid={testid} title={title} className={`p-2 rounded-lg hover:bg-gray-100 ${colore}`}>{children}</button>
);

// Una riga del registro: numero progressivo, FIR, copia firmata, correzioni e annullamento con traccia
export const RitiroCard = ({ prelievo: p, responsabile, onFir, onCaricaFir, onCopia, onCorreggi, onAnnulla }) => {
  const [storico, setStorico] = useState(false);
  const annullato = !!p.annullato;
  const correzioni = (p.storico_correzioni || []).length;
  return (
    <div className={`bg-white rounded-xl p-4 border shadow-sm ${annullato ? 'border-gray-200 opacity-70' : 'border-gray-200'}`} data-testid={`oli-ritiro-${p.id}`}>
      <div className="flex items-start justify-between gap-2">
        <div className="flex-1 min-w-0">
          <div className="flex flex-wrap items-center gap-2 mb-1">
            <span className="text-xs font-semibold text-gray-500" data-testid={`oli-ritiro-numero-${p.id}`}>N. {p.numero_registro}</span>
            <span className={`text-lg font-bold ${annullato ? 'line-through text-gray-400' : 'text-orange-600'}`}>{p.quantita_kg} kg</span>
            <span className="text-sm text-gray-500">{dataIt(p.data_prelievo)}</span>
            {p.numero_fir
              ? <span className="text-xs bg-blue-100 text-blue-700 px-2 py-0.5 rounded">FIR: {p.numero_fir}</span>
              : <span className="text-xs bg-red-100 text-red-700 px-2 py-0.5 rounded">FIR mancante</span>}
          </div>
          <p className="text-sm text-gray-600 truncate"><Truck className="inline h-3.5 w-3.5 mr-1" />{p.trasportatore_nome || 'N/A'}</p>
          <p className="text-sm text-gray-600 truncate"><Building2 className="inline h-3.5 w-3.5 mr-1" />{p.destinatario_nome || 'N/A'}</p>
          <div className="mt-2 flex flex-wrap items-center gap-2">
            <BadgeCopia stato={p.stato_copia} testid={`oli-ritiro-copia-${p.id}`} />
            {p.copia_ritorno?.documento && (
              <a href={urlDocumento(p.id, 'copia')} target="_blank" rel="noreferrer" className="text-xs text-emerald-700 underline"
                data-testid={`oli-ritiro-vedi-copia-${p.id}`}>vedi copia</a>
            )}
          </div>
          {annullato && (
            <p className="text-xs text-gray-600 mt-2" data-testid={`oli-ritiro-annullato-${p.id}`}>
              Annullato il {dataIt(p.annullamento?.data_ora)} da {p.annullamento?.nome}: {p.annullamento?.motivo}
            </p>
          )}
        </div>
        <div className="flex flex-wrap justify-end gap-1 max-w-[9rem]">
          {p.documento_fir
            ? <Azione onClick={() => onFir(p)} testid={`oli-ritiro-vedi-fir-${p.id}`} title="Vedi FIR" colore="text-blue-600"><ImageIcon className="h-5 w-5" /></Azione>
            : !annullato && (
              <label className="p-2 text-gray-400 hover:bg-gray-100 rounded-lg cursor-pointer" title="Carica FIR" data-testid={`oli-ritiro-carica-fir-${p.id}`}>
                <Upload className="h-5 w-5" />
                <input type="file" className="hidden" accept="image/*,.pdf" onChange={(e) => e.target.files[0] && onCaricaFir(p, e.target.files[0])} />
              </label>
            )}
          {!annullato && (!p.copia_ritorno || responsabile) && (
            <Azione onClick={() => onCopia(p)} testid={`oli-ritiro-copia-btn-${p.id}`} title="Copia firmata dall'impianto" colore="text-emerald-700"><FileCheck2 className="h-5 w-5" /></Azione>
          )}
          {!annullato && responsabile && (
            <>
              <Azione onClick={() => onCorreggi(p)} testid={`oli-ritiro-correggi-${p.id}`} title="Correggi"><PencilLine className="h-5 w-5" /></Azione>
              <Azione onClick={() => onAnnulla(p)} testid={`oli-ritiro-annulla-${p.id}`} title="Annulla" colore="text-red-500"><Ban className="h-5 w-5" /></Azione>
            </>
          )}
          {correzioni > 0 && (
            <Azione onClick={() => setStorico(!storico)} testid={`oli-ritiro-storico-btn-${p.id}`} title="Correzioni"><History className="h-5 w-5" /></Azione>
          )}
        </div>
      </div>
      {storico && <Storico prelievo={p} />}
    </div>
  );
};
